import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GlobalSearchRequest,
  GlobalSearchResponse,
} from "../../models/Contact.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

export const globalSearch = createAsyncThunk<
  GlobalSearchResponse,
  GlobalSearchRequest,
  { rejectValue: string }
>("globalSearch/search", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Contact/GlobalSearch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GlobalSearchResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Global search failed");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
